export const EarningsCategories = {
  BOUNTY_REWARD_CLAIMED: { label: "Bounty Rewards", color: "text-pink-500" },
  COIN_TRADING_FEE: { label: "Trading Fees", color: "text-orange-500" },
  PAID_MESSAGE_REDEMPTION: { label: "Paid Messages", color: "text-yellow-500" },
  NEW_SUBSCRIPTION: { label: "Subscriptions", color: "text-purple-500" },
  POST_TIP: { label: "Tips", color: "text-cyan-500" },
  REFERRAL_EARNING: { label: "Revshare (Referrals)", color: "text-indigo-500" },
  UNLOCKABLE_CONTENT: { label: "Gated Content", color: "text-blue-500" },
  COIN_LOCKUP_YIELD: {
    label: "Coin Lockup Yield",
    color: "text-grey-200",
    comingSoon: true,
  },
  POST_2_EARN: {
    label: "Post-to-Earn",
    color: "text-grey-200",
    comingSoon: true,
  },
  VIEW_2_EARN: {
    label: "View-to-Earn",
    color: "text-grey-200",
    comingSoon: true,
  },
  REPOST_2_EARN: {
    label: "Repost-to-Earn",
    color: "text-grey-200",
    comingSoon: true,
  },
} as const;
